import { render, staticRenderFns } from "./InvoiceList.vue?vue&type=template&id=3e896ad5"
import script from "./InvoiceList.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports